module.exports = __webpack_public_path__ + "img/Greenland.e3ff04a6.svg";